module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}



//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/to-array/index.js
// module id = ../../../../to-array/index.js
// module chunks = 4